'use strict';exports.__esModule = true;var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _head = require('lodash/head');var _head2 = _interopRequireDefault(_head);
var _last = require('lodash/last');var _last2 = _interopRequireDefault(_last);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _formatSEOData = require('./formatSEOData');
var _constants = require('../constants');
var _beautifyNumber = require('../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatSavedSearchData = function formatSavedSearchData() {var routeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var locale = arguments[1];var translate = arguments[2];var

  optionType =

  routeData.optionType,_routeData$params = routeData.params,params = _routeData$params === undefined ? {} : _routeData$params;

  var titleObj = {};

  if (!(0, _isEmpty2.default)(params.rooms)) {
    if (params.rooms.length === 1) {
      titleObj.rooms = (0, _head2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
    } else {
      titleObj.rooms =
      (0, _head2.default)(params.rooms) + '-' + (0, _last2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
    }
  }

  if (!(0, _isEmpty2.default)(params.types) && params.types.length === 1) {
    titleObj.types = translate('propertyTypes', params.types[0]);
  } else {
    titleObj.types = translate('SEOsearch', 'realEstateApartments');
  }

  if (!(0, _isEmpty2.default)(params.price)) {
    var minPrice = (0, _get2.default)(params, 'price.minPrice') || '';
    var maxPrice = (0, _get2.default)(params, 'price.maxPrice') || '';

    var priceSeparator = minPrice && maxPrice ? ' - ' : '';
    var comaSeparator = locale === _constants.language.default ? ' ,' : ', ';
    var price = '' + (0, _beautifyNumber2.default)(minPrice) + priceSeparator + (0, _beautifyNumber2.default)(maxPrice);

    if (price) {
      titleObj.price = '' + comaSeparator + price;
    }
  }

  titleObj.optionType = '' + translate('SEOsearch', 'optionType', optionType);

  var searchTitle = '';

  if (locale === _constants.language.default) {
    searchTitle = (0, _formatSEOData.composeHebrewSearchTitle)(titleObj, translate);
  } else {
    searchTitle = (0, _formatSEOData.composeEnglishSearchTitle)(titleObj, translate);
  }

  searchTitle += titleObj.price || '';
  return searchTitle;
};exports.default =

formatSavedSearchData;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatSavedSearchData.js
// module id = 3134
// module chunks = 0